import { useState } from 'react'
import {
  Box,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  TablePagination,
} from '@material-ui/core'

import { MONTHS, getValueForSegment } from './utils'
import { MonthlyDatum, Segment } from './types'

function TableView<Datum extends MonthlyDatum>({
  segments,
  data,
  rowsPerPage,
}: {
  data: Datum[]
  segments: Segment<Datum>[]
  rowsPerPage: number
}) {
  const [page, setPage] = useState(0)

  return (
    <>
      <TableContainer
        component={Box}
        width="100%"
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Month</TableCell>
              {segments.map((segment, idx) => (
                <TableCell
                  key={idx}
                  align="right"
                >
                  {segment.displayName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((m, index) => (
              <TableRow key={index}>
                <TableCell>{MONTHS[m.month - 1]}</TableCell>
                {segments.map((segment, idx) => (
                  <TableCell
                    key={idx}
                    align="right"
                  >
                    {getValueForSegment(m, segment)}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[rowsPerPage]}
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(_, newPage) => {
          setPage(newPage)
        }}
      />
    </>
  )
}

export default TableView
